import { IController, ILocationService } from 'angular';
import * as _ from 'lodash';
import { SdcActionsService } from 'src/app/sdc/flux/sdc-actions.service';
import { ISdcStore, IStoreScope } from 'src/app/sdc/flux/sdc-store.interface';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { CurrentSchoolYear } from '../../../../ng2/shared/constants/current-school-year.constant';
import { ISchool } from '../../../../ng2/shared/typings/interfaces/school.interface';
import { IFilter, TValidSdcKeys, TValidSdcViews } from './../../../sdc/sdc-state/sdc-state.typings';

export class ClassOfDropdownCtrl implements IController {
  static $inject: string[] = ['$scope', '$location', 'SDCStore', 'sdcActions', 'ObjectCache', 'ImSchool'];

  public cohortDropdown;
  public selectedCohort;
  public uiReady: boolean;
  public sdcView: TValidSdcViews = 'wizard';
  public sdcKey: TValidSdcKeys;
  public sdcFilter: IFilter;
  public school: ISchool;
  public seniorCohort: string;

  constructor(
    private $scope: IStoreScope,
    private $location: ILocationService,
    private SDCStore: ISdcStore,
    private sdcActions: SdcActionsService,
    private ObjectCache,
    private ImSchool: ImSchool,
  ) {}

  $onInit(): void {
    this.$scope.$listenTo(this.SDCStore, ['ui', 'isLoading'], () => {
      const isLoading = this.SDCStore.getUiState().isLoading;
      if (!isLoading) this.setUi();
    });
  }

  setUi() {
    this.sdcFilter = this.SDCStore.getFilter();
    this.school = this.SDCStore.getSchool();
    this.cohortDropdown = this.generateDropdown();
    this.seniorCohort = CurrentSchoolYear.ENDFULL;
    this.selectedCohort = this.initializeWithFilter(this.sdcFilter);
    this.sdcView = this.sdcView;
    this.sdcKey = this.SDCStore.getSdcKeyFromUiState();
    this.uiReady = true;
  }

  filterSDCStudentsByCohort(cohort: string | null): void {
    // clear stale filter - will not work locally since delete is forbidden in dev mode
    delete this.sdcFilter.cohort;
    const selectedCohort = cohort || null;
    const isSenior = cohort ? cohort === CurrentSchoolYear.ENDFULL : false;
    const cohortFilter = selectedCohort ? { cohort: [selectedCohort] } : null;

    let newFilter: IFilter;
    if (isSenior) newFilter = this.getFilterForFourthYearCohort();
    else newFilter = Object.assign({}, this.sdcFilter, cohortFilter);

    this.sdcActions.setEntireFilter({
      newFilter,
      sdcKey: this.sdcKey,
      sdcView: this.sdcView,
    });
    this.setFilterParam(newFilter);
  }

  getFilterForFourthYearCohort(): IFilter {
    const seniorAndSuperCohorts = this.ImSchool.getSeniorAndSuperCohorts(this.school);
    return Object.assign({}, this.sdcFilter, { cohort: seniorAndSuperCohorts });
  }

  private generateDropdown() {
    return this.ImSchool.getCurrentCohorts();
  }

  private initializeWithFilter(filter: IFilter) {
    let dropdownItem;
    // cohort filter including supers:
    if (filter.cohort && filter.cohort.length > 1) {
      dropdownItem = _.head(this.cohortDropdown);
      // year specific cohort filter:
    } else if (filter.cohort && filter.cohort.length === 1) {
      dropdownItem = _.head(filter.cohort);
      // no cohort filter:
    } else dropdownItem = null;

    this.setFilterParam(filter);
    return dropdownItem;
  }

  private setFilterParam(filter: IFilter): void {
    const filterHash = this.ObjectCache.cacheObject(filter);
    this.$location.search('filter', filterHash).replace();
  }
}
